@use "foundation/colors";

// Figma 1818-319796 ("permission" in the Applet Card).
.paused-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border: 0;
  border-radius: 16px;

  // The Figma stroke is outside, over the card color; a shadow draws it there without
  // changing the chip size.
  box-shadow: 0 0 0 2px rgb(255 255 255 / 30%);
  color: colors.$text-primary-on-dark;
  font-family: inherit;
  text-align: start;
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: colors.$text-primary-on-dark;
  }

  // The global reset removes outlines; the Figma has no focused chip, so the focus ring is
  // the border at full white.
  &:focus-visible {
    box-shadow: 0 0 0 2px colors.$text-primary-on-dark;
  }
}

.icon {
  display: flex;
  flex-shrink: 0;
}

.label {
  flex: 1;
  min-inline-size: 0;
}

// The chip's block size: 16px padding on each side of the 20px icon.
.space {
  block-size: 52px;
}

// The chip sits over the space the card keeps for it, inside the card's 24px padding, and
// above the card body (z-index 1 in application/components/_applet_card.scss).
.over-card {
  position: absolute;
  z-index: 2;
  inset-inline: 24px;
  inset-block-end: 24px;
}
